import { render, staticRenderFns } from "./Relatorios.vue?vue&type=template&id=89944668&"
import script from "./Relatorios.vue?vue&type=script&lang=js&"
export * from "./Relatorios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports